<script setup>
import {Button} from "@/Components/Library";
import {useInstall} from "@/Composables/useInstall";

const {show, isIos, showInstallPrompt, dismissInstallPrompt} = useInstall();

const appName = import.meta.env.VITE_APP_NAME;
</script>
<template>
    <Transition>
        <div
            v-if="show.install"
            class="fixed inset-x-0 bottom-3 z-50 mx-auto max-w-sm rounded-md bg-stone-900/90 p-4 text-white shadow-lg shadow-black backdrop-blur-sm"
        >
            <div class="mb-0 flex items-center">
                <h3 class="font-display mr-auto text-lg font-bold text-askr-green-500">Add to Home Screen</h3>
                <Button
                    @click="dismissInstallPrompt"
                    class="px-2 text-white"
                    icon="prime:times"
                    text
                    rounded
                    size="small"
                />
            </div>
            <p class="mb-6">Install the {{ appName }} app to use it in fullscreen and while offline.</p>
            <div v-if="isIos">
                <div class="mb-3 flex items-center">
                    <span class="mr-2 text-3xl text-askr-green-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path
                                fill="currentColor"
                                d="M17 8h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2v2H5v9h14v-9h-2zM6.5 5.5l1.414 1.414L11 3.828V14h2V3.828l3.086 3.086L17.5 5.5L12 0z"
                            />
                        </svg>
                    </span>
                    <span>1. Press the 'Share' button</span>
                </div>
                <div class="mb-3 flex items-center">
                    <span class="mr-2 text-3xl text-askr-green-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024">
                            <path
                                fill="currentColor"
                                d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32M704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8z"
                            />
                        </svg>
                    </span>
                    <span>2. Press 'Add to Home Screen'</span>
                </div>
                <div>
                    <img :src="`/images/ios-share.png`" class="w-full" alt="iOS share" />
                </div>
            </div>
            <div v-else class="flex justify-center">
                <Button @click="showInstallPrompt" class="w-full rounded bg-askr-green px-4 py-2 font-bold text-white">
                    Install
                </Button>
            </div>
        </div>
    </Transition>
</template>
<style>
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.25s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
